import React from 'react';
import cx from 'classnames';

import SmartLink from '../SmartLink';

import { Body2, Heading6 } from '../Typography';
import { ReactComponent as ArrowRightIcon } from '../../assets/svg/arrow-right-white.svg';

import styles from './index.module.scss';

export enum StickyButtonType {
  LINK = 'link',
  BUTTON = 'button',
}

export interface StickyButtonProps {
  isVisible: boolean;
  title: string;
  text?: string;
  className?: string;
  type?: StickyButtonType;
  link?: string;
  onClick?: () => void;
}

const StickyButton = ({
  title,
  text,
  link,
  onClick,
  isVisible,
  className,
  type = StickyButtonType.LINK,
}: StickyButtonProps) => {
  const content = (
    <div className={styles.content}>
      <div className={styles.textWrapper}>
        <Heading6 className={styles.title}>{title}</Heading6>
        {text && <Body2 className={styles.text}>{text}</Body2>}
      </div>
      <ArrowRightIcon className={styles.arrow} />
    </div>
  );

  const wrapperClasses = cx(
    styles.wrapper,
    {
      [styles.visible]: isVisible,
    },
    className && { [className]: true },
  );

  if (type === StickyButtonType.BUTTON) {
    return (
      <button className={wrapperClasses} onClick={onClick} type='button'>
        {content}
      </button>
    );
  }

  return (
    <SmartLink className={wrapperClasses} to={link || '#'}>
      {content}
    </SmartLink>
  );
};

export default StickyButton;
